// API接口站点
export const DOMAIN = process.env.NODE_ENV === 'dev' ? 'http://hyao.hengxuan.phoebe/' : '/';

// 缓存版本号
export const CACHE_VERSION = '1.2.8';

// 域名发布器下载
export const DOMAIN_EXE = 'http://yw.xcnice.com/yw-update/sincai_speedtest_v1.0.1.exe';

// 域名验证
export const DOMAIN_CHECK = 'http://sincaiurl.com';

// adobe air 下载地址
export const DOWNLOAD_ADOBEAIR = 'http://get.adobe.com/cn/air/adobe';

// PT PC 客户端下载地址
export const DOWNLOAD_PT_PC = 'http://cdn.vbet.club/happyslots/d/setupglx.exe';

// Win客户端
export const DOWNLOAD_WIN = 'http://dl.bfzyds.com/cef/xy/setup.msi';

// Mac客户端
export const DOWNLOAD_MAC = 'http://dl3.enjoysincai.net/download/Main.air';

// 恒耀app下载二维码地址
export const DOWNLOAD_APP_QR = 'https://zhmobile.hhmlmj.com/hy/app/h5code.png';

// 众合app下载二维码地址
export const ZH_DOWNLOAD_APP_QR = 'https://zhmobile.hhmlmj.com/zh/app/h5code.png';

// app挂机软件下载二维码地址
export const DOWNLOAD_APP_HANGUP_QR = 'https://dn-scmobile.qbox.me/xy_auto/download/xyqr.png';

//众合挂机软件下载
export const DOWNLOAD_HANGUP_PC = 'http://dl4.enjoysincai.net/download/xy_auto.exe';

//众合挂机软件说明文档下载
export const DOWNLOAD_HANGUP_README = 'https://dn-scmobile.qbox.me/xy_auto/pc/众合系列挂机说明书及常见问题.zip';

//下载中心
export const DOWNLOAD_CENTER = 'https://zhmobile.hhmlmj.com/hy/app/index.html';

//性耀之旅
export const ACTIVITY_EUROPE = 'static/activity/europe/index.html';

//性耀之旅2
export const ACTIVITY_SOUTHASIA = 'static/activity/xy/index.html';

// 浏览器下载地址
export const BROWSER_DOWNLOAD = {
  CHROME: 'https://pan.baidu.com/s/1pEFEY12LN_15wxdeJfkLMw',
  IE: 'https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads',
  FIREFOX: 'https://pan.baidu.com/s/1pPtL1rsVF4nIAzkm75L6Zw',
  SOGOU: 'https://pan.baidu.com/s/1fhmoEkJ8z4ML3PmWINu3ug'
};

// 开奖官网
export const DRAW_WEB = {
  hn5fc: 'http://draw.vietlotto.org/',
  hn1fc: 'http://draw.vietlotto.org/',
  rd1fc: 'https://www.swedishlottery.se/lotto/sevenstars',
  rd2fc: 'https://www.swedishlottery.se/lotto/KNX',
  txffc: 'http://vip.manycai.com/Issue/history?lottername=TXFFC',
  jnd30m: 'http://www.canadasuperdraw.com/30s/',
  jnd11x5: 'https://www.canadasuperdraw.com/canadapick5/',
  '3djnd': 'https://www.canadasuperdraw.com/canada3d/',
  ynffc: 'http://draw.indonesia-lottery.org/',
  rbffc: 'http://takarakuji-numbers.org/',
  xgffc: 'http://draw.24xoso.com/',
  txdsq:'http://vip.manycai.com/Issue/history?lottername=TXFFC',
  txssq:'http://vip.manycai.com/Issue/history?lottername=TXFFC',
  txwfc:'http://vip.manycai.com/Issue/history?lottername=TXFFC',
  xyft: 'http://mairship.com/',
	syqiqu: 'https://77tj.online/tencent',
};

// 客户端来源
export const CLIENT_SOURCE = {
  'others': 0,
  'web': 1,
  'cef': 7,
  'ios': 8,
  'android': 9,
  'hangup': 10 // 挂机软件
};

// 客户端ID
export const CLIENT_ID = {
	'PC': '10000001',
	'H5': '10000002',
	'APP': /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? '10000004' : '10000003'
};


//恒耀快速登录器下载地址
export const DOWNLOAD_FAST_LOGIN = 'https://zhmobile.hhmlmj.com/hy/download/SpeedTest.exe';

//众合挂机软件下载地址
export const DOWNLOAD_AUTOLOTT_PC = 'http://dl3.enjoysincai.net/download/zh_auto.msi';

//恒耀挂机软件下载地址
export const HY_DOWNLOAD_AUTOLOTT_PC = 'https://zhmobile.hhmlmj.com/hy/pc_down/index.html';

//恒耀客户端下载地址
export const DOWNLOAD_CEF_PC = 'https://zhmobile.hhmlmj.com/hy/cef/setup.msi';

//最优线路网址
export const SPEEP_PC = 'https://www.518hengy.com';

// 多彩分析预测地址
export const MANYCAI_ANALYSE = {
	['cqssc']: 'id=CQSSC&chart=numAnalysis', 
	['xjssc']: 'id=XJSSC&chart=numAnalysis',
	['天津时时彩']: 'id=TJSSC&chart=numAnalysis',
	['jdcqssc']: 'id=JDCQSSC&chart=numAnalysis', 
	['cqffc']: 'id=CQFFC&chart=numAnalysis', 
	['txffc']: 'id=TXFFC&chart=numAnalysis', 
	['qq1fc']: 'id=QQFFC&chart=numAnalysis', 
	['sytxffc']: 'id=PTXFFC&chart=numAnalysis', 
	['txssq']: 'id=TX2FCS&chart=numAnalysis', 
	['txdsq']: 'id=TX2FCD&chart=numAnalysis', 
	['cq5fc']: 'id=CQ5FC&chart=numAnalysis', 
	['txwfc']: 'id=TX5FC&chart=numAnalysis', 
	['qq30m']: 'id=QQ30S&chart=numAnalysis', 
	['cq30s']: 'id=CQSSC30S&chart=numAnalysis', 
	['tx30s']: 'id=TXFFC30S&chart=numAnalysis', 
	['pk10']: 'id=BJPK10&chart=numAnalysis', 
	['香港PK10']: 'id=XGPK10&chart=numAnalysis', 
	['腾讯PK10']: 'id=TXPK10&chart=numAnalysis', 
	['jssc']: 'id=MCPK10&chart=numAnalysis', 
	['xyft']: 'id=XIYFT&chart=numAnalysis', 
	['皇家幸运飞艇']: 'id=XYFT&chart=numAnalysis', 
	['gd11x5']: 'id=GD11X5&chart=numAnalysis', 
	['sd11x5']: 'id=SD11X5&chart=numAnalysis', 
	['jx11x5']: 'id=JX11X5&chart=numAnalysis', 
	['上海11选5']: 'id=SH11X5&chart=numAnalysis', 
	['安徽11选5']: 'id=AF11X5&chart=numAnalysis', 
	['hlj11x5']: 'id=HLJ11X5&chart=numAnalysis', 
	['js11x5']: 'id=JS11X5&chart=numAnalysis', 
	['ln11x5']: 'id=LL11X5&chart=numAnalysis', 
	['gx11x5']: 'id=GX11X5&chart=numAnalysis', 
	['yn11x5']: 'id=YN11X5&chart=numAnalysis', 
	['hb11x5']: 'id=HB11X5&chart=numAnalysis', 
	['江苏快三']: 'id=JSKS&chart=numAnalysis', 
	['hnks']: 'id=HLK3&chart=numAnalysis', 
	['湖北快三']: 'id=HBK3&chart=numAnalysis', 
	['jlks']: 'id=JLK3&chart=numAnalysis', 
	['安徽快三']: 'id=AHK3&chart=numAnalysis', 
	['广西快三']: 'id=GXKS&chart=numAnalysis', 
	['广西快乐10']: 'id=GXKL10&chart=historyNum&tab=Happy81012', 
	['广东快乐10']: 'id=GDKL10&chart=numAnalysis', 
	['天津快乐10']: 'id=TJKL10&chart=numAnalysis', 
	['湖南快乐10']: 'id=HNKL10&chart=numAnalysis', 
	['重庆幸运农场']: 'id=CQXYNC&chart=numAnalysis', 
	['3dfc']: 'id=FC3D&chart=numAnalysis', 
	['体彩P3']: 'id=TCPL3&chart=numAnalysis', 
	['体彩排列5']: 'id=TCPL5&chart=numAnalysis', 
	['香港六合彩']: 'id=XGLHC&chart=historyNum&tab=LotNation', 
	['hn5fc']: 'id=HN300&chart=numAnalysis', 
	['hn1fc']: 'id=HN60&chart=numAnalysis', 
	['jnd30m']: 'id=JND30S&chart=numAnalysis', 
	['jnd3d']: 'id=JND3D&chart=numAnalysis', 
	['jnd11x5']: 'id=JND11X5&chart=numAnalysis', 
	['ynwfc']: 'id=YN300&chart=numAnalysis', 
	['ynffc']: 'id=YN60&chart=numAnalysis', 
	['rbffc']: 'id=RB60&chart=numAnalysis', 
	['tg60s']: 'id=TG60&chart=numAnalysis', 
	['tg300s']: 'id=TG300&chart=numAnalysis', 
	['tg11x5']: 'id=TG11X5&chart=numAnalysis', 
	['xgffc']: 'id=XG60&chart=numAnalysis', 
	['xgwfc']: 'id=XG300&chart=numAnalysis', 
	['rd1fc']: 'id=RD60&chart=historyNum&tab=LotOversea',
	['rd2fc']: 'id=RD120&chart=historyNum&tab=LotOversea',
	['摩纳哥Super 52']: 'id=MNG52&chart=historyNum&tab=LotOversea',
	['jssm']: 'id=JSSM&chart=historyNum&tab=LotOversea',
	['上海时时乐']: 'id=SHSSL&chart=numAnalysis'
}